import React, { FC } from 'react'
import { createStyles, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { LoadRecommendation } from 'apps/fleet-planner/types'
import { ViewMoreLikeThisHistoricalLanesButton } from '../../ViewMoreLikeThisHistoricalLanesButton'

const useStyles = makeStyles(theme =>
  createStyles<string, { mobile: boolean | undefined }>({
    root: {
      paddingTop: ({ mobile }) => (mobile ? theme.spacing(2) : theme.spacing(0)),
    },
    location: {
      fontWeight: theme.typography.fontWeightBold,
    },
    coolGray4Bg: {
      backgroundColor: brandColors.coolGray4,
    },
  })
)

interface IBookableShipmentSearchRunItAgainBookLaneProps {
  loadRecommendation: LoadRecommendation
}

export const BookableShipmentSearchRunItAgainBookLane: FC<IBookableShipmentSearchRunItAgainBookLaneProps> = ({
  loadRecommendation,
}) => {
  const { deliveryCity, deliveryStateCode, pickupCity, pickupStateCode } = loadRecommendation || {}
  const { isMobile } = useBreakpointContext()
  const classes = useStyles({ mobile: isMobile })

  return (
    <div className={classes.root}>
      <Typography color='textSecondary' variant='body1'>
        Based on your load from
      </Typography>
      <Typography component='span' className={classes.location}>
        {`${pickupCity}, ${pickupStateCode}`}
      </Typography>
      <Typography component='span' color='textSecondary' variant='body1'>
        {' '}
        to{' '}
      </Typography>
      <Typography component='span' className={classes.location}>
        {`${deliveryCity}, ${deliveryStateCode} `}
      </Typography>
      {!isMobile && (
        <ViewMoreLikeThisHistoricalLanesButton loadRecommendation={loadRecommendation} />
      )}
    </div>
  )
}
